import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  byId: {},
  allIds: [],
};

const upsertOne = (state, p) => {
  if (!p || !p.id) return;
  const exists = !!state.byId[p.id];
  state.byId[p.id] = { ...(state.byId[p.id] || {}), ...p };
  if (!exists) state.allIds.unshift(p.id);
};

const projectEntitiesSlice = createSlice({
  name: 'projectEntities',
  initialState,
  reducers: {
    upsertProject: (state, action) => {
      upsertOne(state, action.payload);
    },
    upsertProjects: (state, action) => {
      const list = Array.isArray(action.payload) ? action.payload : [];
      // Insert newest first if createdAt is present
      list
        .slice()
        .sort((a, b) => {
          const ta = a?.createdAt?.toDate?.() ? a.createdAt.toDate().getTime() : (a?.createdAt ? new Date(a.createdAt).getTime() : 0);
          const tb = b?.createdAt?.toDate?.() ? b.createdAt.toDate().getTime() : (b?.createdAt ? new Date(b.createdAt).getTime() : 0);
          return tb - ta;
        })
        .forEach(p => upsertOne(state, p));
    },
    removeProject: (state, action) => {
      const id = action.payload;
      if (!id) return;
      if (state.byId[id]) delete state.byId[id];
      state.allIds = state.allIds.filter(pid => pid !== id);
    },
    clearProjectsCache: () => ({ ...initialState })
  }
});

export const { upsertProject, upsertProjects, removeProject, clearProjectsCache } = projectEntitiesSlice.actions;
export default projectEntitiesSlice.reducer;

// Selectors
export const selectProjectById = (state, id) => state.projectEntities?.byId?.[id];
export const selectProjectsByCreator = (state, creatorId) => {
  const ids = state.projectEntities?.allIds || [];
  const byId = state.projectEntities?.byId || {};
  const list = ids.map(id => byId[id]).filter(p => p && p.creatorId === creatorId);
  return list.slice().sort((a, b) => {
    const ta = a?.createdAt?.toDate?.() ? a.createdAt.toDate().getTime() : (a?.createdAt ? new Date(a.createdAt).getTime() : 0);
    const tb = b?.createdAt?.toDate?.() ? b.createdAt.toDate().getTime() : (b?.createdAt ? new Date(b.createdAt).getTime() : 0);
    return tb - ta;
  });
};
